import styled from 'styled-components';
import { COLOR, mobile } from '../../../styles/variables';

export const Wrapper = styled.header<{ bg?: string; isBig?: boolean; navbarHeight?: string }>`
    display: flex;
    margin-top: ${({ navbarHeight }) => navbarHeight || 0};
    background: ${COLOR.br24.darkBlueGrey};
    transition: all 0.25s;
`;
